export default __webpack_public_path__ + "static/media/step2.da596318.webp";